import { LibraryPage } from "../LibraryPage";
import { RejectedDocuments } from "./RejectedDocuments";

/** The URLs the corpus admission gate rejected for good. */
export default function Rejected() {
  return (
    <LibraryPage>
      <RejectedDocuments />
    </LibraryPage>
  );
}
